import {AbstractEvent} from "@/modules/base/events";
import {GroundSlot} from "@/modules/club-grounds/entity";

export class AfterGroundSlotDemolishedEvent extends AbstractEvent {
  constructor(
    public groundSlot: GroundSlot
  ) {
    super();
  }
}